function logVisit() {
	if (window.visitLogTimeout) {
		clearTimeout(window.visitLogTimeout);
		window.visitLogTimeout = 0;
	}

	var callLog = true;

	if (!document.hasFocus()) {
		// console.log('document does not have focus, skipping log visit');
		callLog = false;

	} else if (Math.floor(Date.now() / 1000) - window.visitLastInteraction > 120) {
		// console.log('last interaction more than 120 seconds ago, skipping log visit');
		callLog = false;
	}

	if (callLog) {
		// console.log('log visit', window.visitLastInteraction);
		$.post('/site/ajax/page_visit.php', {page_id: window.visitPageId, visit_id: window.visitId})
			.done(function(data) {
				window.visitId = data.visit_id;
			});
	}

	window.visitLogTimeout = setTimeout(logVisit, 30 * 1000);
}

function startVisitLogging() {
	if (window.visitLogTimeout) {
		return;
	}

	// console.log('start logging visit');

	$(document).on('click.log_visit', () => {
		// console.log('updating last interaction timestamp');
		window.visitLastInteraction = Math.floor(Date.now() / 1000);
	}).trigger('click.log_visit');

	logVisit();
}

function stopVisitLogging() {
	if (window.visitLogTimeout) {
		// console.log('stop logging visit');
		$(document).off('click.log_visit');
		clearTimeout(window.visitLogTimeout);
		window.visitLogTimeout = 0;
	}
}

if (window.visitLogAutostart) {
	$(function() {
		startVisitLogging();
	});
}
